import { PayloadAction } from '@reduxjs/toolkit';

import { GangSheetState } from 'editor/src/store/gangSheet/types';

const setGapMmReducer = (state: GangSheetState, action: PayloadAction<number>) => {
  state.gapMm = action.payload;
};

export default setGapMmReducer;
